import selectn from 'selectn'
import { common } from '../../common'
import helpers from './helpers'
export const modules = {
	/**
   * [getStandings get Rugby standings data]
   * @param  {[type]} standingsData [raw data object]
   * @param  {[type]} league [raw data object]
   * @param  {[type]} params [raw data object]
   * @return {[type]} [object]
   */
  getStandings(standingsData,league, params = {}) {
    const typesToShow = [ /* stats type in order of display + special team to show teamname */
      'rank',
      'team',
      'gamesplayed',
      'pointsdifference',
      'points'
    ]
    const standings = common.getStandingsData(standingsData, typesToShow, params.sport, 'TeamClubhouse' )
    const standingsLink = common.getStandingsLink({ ...params, leagueId: standingsData.id }, {}, 'TeamClubhouse' )
    standings.title = `${selectn('season.year', league) || ''} ${standings.title} Table`
    return { ...standings, link : { ...standingsLink, external :true }, displayKey : 'displayName', params }
  },
  
  /**
   * get ordered array of chart input data which is a comparison of current team vs highest rated team
   * @param  {Object} standingsData [raw data object]
   * @param  {Object} team [raw data object]
   * @return {Object}           [object]
   */

  getTeamRankings(standingsData, team = {}) {
    const processedStats = helpers.getProcessedStats(selectn('feed.children', standingsData))
    if(!processedStats.length) {
      return
    }
    const triesComp = helpers.getStatComparison(processedStats,'triesfor', team.id)    
    const pointsComp= helpers.getStatComparison(processedStats, 'pointsdifference', team.id)
    const triesChart = {
      ...triesComp,
      heading : 'TRIES SCORED',
      subHeading : '',
      chartType : 'curve',
      statName : 'Tries'
    }
    triesChart.subHeading = helpers.getChartSubHeading({ ...triesComp , type : 'Tries Scored' })
    const pointsChart = {
      ...pointsComp,
      heading : 'POINTS DIFFERENCE',
      subHeading : '',
      chartType : 'line',
      statName : 'points'
    }
    pointsChart.subHeading = helpers.getChartSubHeading({ ...pointsComp, type : 'Points Difference' })
    const title = `${selectn('league.season.year', standingsData)} Rankings`
    const subtitle = selectn('league.name', standingsData)
    // check if current team is top in all the comparison of stats
    const tracking = common.createTrackingName([ 'Rugby', 'TeamClubhouse' , 'Rankings', 'Full' ])    
    const isAllTop = (selectn('homeTeam.rank', pointsComp) == 1 && selectn('homeTeam.rank', triesComp) == 1) ? true : false
    const link = { href:helpers.getStatsguruLink(team.id), title : 'Full Statistics', external:true, trackingName : tracking }
    return {
      title : title,
      subtitle : subtitle,
      isAllTop : isAllTop,
      charts : [ triesChart, pointsChart ],
      link : link,
      teamColor:'#'+team.color
    } 
  },

  /**
   * get getTopScorers
   * @param  {Object} leaders [raw data object]
   * @param  {Object} team [raw data object]
   * @param  {[type]} params [raw data object]
   * @return {Object} topScorers categorized by points / tries [object]
   */

  getTopScorers(leadersNode, team = {}, params = {}) {
    let topScorers = {
      season : selectn('league.season.year', leadersNode) || '',
      trackingName : common.createTrackingName(
        [ params.sport, 
          params.pageType+'clubhouse', 
          'performers', 'player' 
        ]),
      players : [],
      subtitle : selectn('league.name', leadersNode) || '',
      link : {
        href:common.buildURL(helpers.getStatsguruLink(team.id)) || '#', 
        title : 'Full Team Statistics', 
        external:true, 
        teamColor:'#'+team.color, 
        trackingName: common.createTrackingName(
          [ params.sport, 
            params.pageType+'clubhouse', 
            'performers', 'full' 
          ]) || ''
      }
    }
    const players = selectn('feed[0]', leadersNode) || []
    const playLen = players.length || 0
    let pointsTries = ''
    let displayCat = ''
    for(let i=0; i<playLen; i++) {
      let leaders = []
      const player = selectn('statCategories[0].leaders', players[i]) || []
      const playerLen = player.length || 0
      pointsTries = selectn('statCategories[0].displayName', players[i]) || ''
      displayCat = selectn('name', players[i]) || ''
      for(let e=0; e<playerLen; e++) {
        const ePlayer = player[e]
        if(!playerLen || ePlayer.displayValue === 'undefined') {
          return
        }
        const playerStats = ePlayer.displayValue.split(', ')
        const playerStLen = playerStats.length || 0
        const stats = []
        for(let e=0; e<playerStLen; e++) {
          const stat = playerStats[e].split(': ')
          stats[stat[0]]= stat[1]
        }
        let headshot = selectn('headshot', ePlayer.athlete) || ''
        headshot = headshot ? common.resizeCombinerLogo(headshot,
                   { w:108, h:75, transparent:true, scale:'crop'  } ) : ''
        let position = selectn('position.abbreviation', ePlayer.athlete) || ''
        position = position !== '' ? ', '+ position : '' 
        leaders.push({
          name: selectn('displayName', ePlayer.athlete) || '',
          position: position,
          href: common.buildURL(selectn('links[0].href', ePlayer.athlete)) || '#',
          stats: displayCat === 'points' ? stats.P : stats.T || '',
          matches: 'Matches ' + stats.M || '',
          img: headshot || ''
        })
      }
      topScorers.players.push( {
        displayCat: displayCat, 
        displayName: pointsTries, 
        leaders: leaders
      } )
    }
    return topScorers
  }
}

export default modules



// WEBPACK FOOTER //
// ../app/lib/transform/parsers/rugby/clubhouse/modules.js